import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://jipafqwbwbggzagelocn.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImppcGFmcXdid2JnZ3phZ2Vsb2NuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzU1Nzk4NjUsImV4cCI6MjA1MTE1NTg2NX0.zEceJImP1gAQUdqq9mmO4H2bv1CT_qF4bWcgvYFCfU8";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
